import { jsx as _jsx } from "react/jsx-runtime";
import { ClientCard } from '../components/client-card.js';
import { ClientSearchField } from '../fields/client-search-field.js';
import { withFieldGroup } from '../hooks/use-app-form.js';
import { ContactSection } from './contact-section';
export const ClientSection = withFieldGroup({
    defaultValues: {},
    props: {},
    render: function Render({ children, group, mode, onClientSelected, selectedClient }) {
        // Edit mode: show read-only client card
        if (mode === 'edit') {
            return (_jsx(ContactSection, { fields: {
                    clientFirstName: 'clientFirstName',
                    clientLastName: 'clientLastName',
                    contactEmail: 'contactEmail',
                    contactPhoneNumber: 'contactPhoneNumber',
                }, form: group, title: "Client", hideFields: true, headerContent: _jsx(group.Subscribe, { selector: (state) => ({
                        email: state.values.contactEmail,
                        firstName: state.values.clientFirstName,
                        lastName: state.values.clientLastName,
                        phoneNumber: state.values.contactPhoneNumber,
                    }), children: (clientInfo) => (_jsx(ClientCard, { client: {
                            email: clientInfo.email,
                            firstName: clientInfo.firstName,
                            lastName: clientInfo.lastName,
                            phoneNumbers: clientInfo.phoneNumber
                                ? [{ number: clientInfo.phoneNumber, type: 'PRINCIPAL' }]
                                : [],
                        }, mode: "readonly" })) }), children: children }));
        }
        // Create mode with client search
        if (onClientSelected) {
            return (_jsx(ContactSection, { fields: {
                    clientFirstName: 'clientFirstName',
                    clientLastName: 'clientLastName',
                    contactEmail: 'contactEmail',
                    contactPhoneNumber: 'contactPhoneNumber',
                }, form: group, title: "Client", hideFields: !!selectedClient, headerContent: _jsx(ClientSearchField, { onClientSelected: (client) => {
                        onClientSelected(client);
                        if (client) {
                            group.setFieldValue('contactEmail', client.email ?? '');
                            group.setFieldValue('clientFirstName', client.firstName);
                            group.setFieldValue('clientLastName', client.lastName);
                            group.setFieldValue('contactPhoneNumber', client.phoneNumbers?.find((p) => p.type === 'PRINCIPAL')?.number ??
                                client.phoneNumbers?.[0]?.number ??
                                '');
                        }
                        else {
                            group.setFieldValue('contactEmail', '');
                            group.setFieldValue('clientFirstName', '');
                            group.setFieldValue('clientLastName', '');
                            group.setFieldValue('contactPhoneNumber', '');
                        }
                        group.setFieldMeta('contactEmail', (prev) => ({ ...prev, errors: [] }));
                        group.setFieldMeta('clientFirstName', (prev) => ({ ...prev, errors: [] }));
                        group.setFieldMeta('clientLastName', (prev) => ({ ...prev, errors: [] }));
                        group.setFieldMeta('contactPhoneNumber', (prev) => ({ ...prev, errors: [] }));
                    }, selectedClient: selectedClient ?? null }), children: children }));
        }
        // Fallback: simple contact fields
        return (_jsx(ContactSection, { fields: {
                clientFirstName: 'clientFirstName',
                clientLastName: 'clientLastName',
                contactEmail: 'contactEmail',
                contactPhoneNumber: 'contactPhoneNumber',
            }, form: group, title: "Client", children: children }));
    },
});
